module.exports = __webpack_public_path__ + "img/auth.6df7a689.jpg";